"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regularHoursDetails = exports.getRegularRateHours = exports.getJobBillingDetails = void 0;
const currency_1 = require("../currency");
const getJobBillingDetails = (job) => {
    const { regularPayout, averageRegularRate, regularHours } = (0, exports.regularHoursDetails)(job);
    const { overtimePayout, averageOvertimeRate, overtimeHours } = overtimeHoursDetails(job);
    const { doublePayout, averageDoubleRate, doubleHours } = doubleHoursDetails(job);
    const { onCallPayout, averageOnCallRate, onCallHours } = onCallHourDetails(job);
    const totalHours = duration(job.job_billing_sums?.total_hours ?? 0);
    const totalPayout = (0, currency_1.centsToCurrency)(job.job_billing_sums?.payout_total_amount_cents ?? 0);
    const breakHours = duration(job.job_billing_sums?.total_breaks_hours ?? 0);
    return {
        regularPayout,
        averageRegularRate,
        regularHours,
        overtimePayout,
        averageOvertimeRate,
        overtimeHours,
        doublePayout,
        averageDoubleRate,
        doubleHours,
        onCallPayout,
        averageOnCallRate,
        onCallHours,
        totalHours,
        totalPayout,
        breakHours,
    };
};
exports.getJobBillingDetails = getJobBillingDetails;
const duration = (hours) => `${Math.floor(hours)}h ${Math.floor((hours % 1) * 60)}m`;
const noOvertimeMultiplier = (job) => job.payout_overtime_multiplier === 1.0;
const getRegularRateHours = (job) => {
    const noOvertime = noOvertimeMultiplier(job);
    const combinedRegularAndOTHours = (job.job_billing_sums?.payout_regular_hours ?? 0) +
        (job.job_billing_sums?.payout_overtime_hours ?? 0);
    const combinedRegularAndOTCharge = (job.job_billing_sums?.payout_regular_amount_cents ?? 0) +
        (job.job_billing_sums?.payout_overtime_amount_cents ?? 0);
    const regularHours = duration(noOvertime ? combinedRegularAndOTHours : job.job_billing_sums?.payout_regular_hours ?? 0);
    const regularPayout = (0, currency_1.centsToCurrency)(noOvertime
        ? combinedRegularAndOTCharge
        : job.job_billing_sums?.payout_regular_amount_cents ?? 0);
    const regularRateCents = (() => {
        if (noOvertime) {
            return combinedRegularAndOTCharge && combinedRegularAndOTHours
                ? combinedRegularAndOTCharge / combinedRegularAndOTHours
                : null;
        }
        else {
            return job.job_billing_sums?.payout_regular_amount_cents &&
                job.job_billing_sums?.payout_regular_hours
                ? job.job_billing_sums?.payout_regular_amount_cents /
                    job.job_billing_sums?.payout_regular_hours
                : null;
        }
    })();
    return {
        averageRegularRate: regularRateCents ? (0, currency_1.centsToCurrency)(regularRateCents) : null,
        regularPayout,
        regularHours,
    };
};
exports.getRegularRateHours = getRegularRateHours;
const regularHoursDetails = (job) => {
    const { averageRegularRate, regularPayout, regularHours } = (0, exports.getRegularRateHours)(job);
    return { averageRegularRate, regularPayout, regularHours };
};
exports.regularHoursDetails = regularHoursDetails;
const overtimeHoursDetails = (job) => {
    const noOvertime = noOvertimeMultiplier(job);
    const combinedCallbackAndOTHours = (job.job_billing_sums?.payout_callback_hours ?? 0) +
        (job.job_billing_sums?.payout_overtime_hours ?? 0);
    const combinedCallbackAndOTCharge = (job.job_billing_sums?.payout_callback_amount_cents ?? 0) +
        (job.job_billing_sums?.payout_overtime_amount_cents ?? 0);
    const overtimeHours = duration(noOvertime ? job.job_billing_sums?.payout_callback_hours ?? 0 : combinedCallbackAndOTHours);
    const overtimePayout = (0, currency_1.centsToCurrency)(noOvertime
        ? job.job_billing_sums?.payout_callback_amount_cents ?? 0
        : combinedCallbackAndOTCharge);
    const overtimeRateCents = (() => {
        if (noOvertime) {
            return job.job_billing_sums?.payout_callback_amount_cents &&
                job.job_billing_sums?.payout_callback_hours
                ? job.job_billing_sums?.payout_callback_amount_cents /
                    job.job_billing_sums?.payout_callback_hours
                : null;
        }
        else {
            return combinedCallbackAndOTHours && combinedCallbackAndOTHours
                ? combinedCallbackAndOTCharge / combinedCallbackAndOTHours
                : null;
        }
    })();
    const averageOvertimeRate = overtimeRateCents ? (0, currency_1.centsToCurrency)(overtimeRateCents) : null;
    return { overtimePayout, averageOvertimeRate, overtimeHours };
};
const doubleHoursDetails = (job) => {
    const doubleHours = duration(job.job_billing_sums?.payout_double_hours ?? 0);
    const doublePayout = (0, currency_1.centsToCurrency)(job.job_billing_sums?.payout_double_amount_cents ?? 0);
    const averageDoubleRate = job.job_billing_sums?.payout_double_hours &&
        job?.payout_base_hourly_rate_cents &&
        job.payout_double_overtime_multiplier
        ? (0, currency_1.centsToCurrency)(job.payout_base_hourly_rate_cents * job.payout_double_overtime_multiplier)
        : null;
    return { doublePayout, averageDoubleRate, doubleHours };
};
const onCallHourDetails = (job) => {
    const onCallHours = duration(job.job_billing_sums?.total_on_call_hours ?? 0);
    const onCallPayout = (0, currency_1.centsToCurrency)(job.payout_on_call_hourly_rate_cents && job.job_billing_sums?.total_on_call_hours
        ? job.job_billing_sums?.total_on_call_hours * job.payout_on_call_hourly_rate_cents
        : 0);
    const averageOnCallRate = job.payout_on_call_hourly_rate_cents && job.job_billing_sums?.total_on_call_hours
        ? (0, currency_1.centsToCurrency)(job.payout_on_call_hourly_rate_cents)
        : null;
    return { onCallPayout, averageOnCallRate, onCallHours };
};
